module.exports = __webpack_public_path__ + "src/assets/images/volums/sound/volum_circle4.png?b424b29171ef70f9c8aa290852db1a80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/sound/volum_circle4.png
// module id = 673
// module chunks = 0